import Vue from 'vue'

import Cookies from 'js-cookie'
import {
  getLocalStorage,
  saveLocalStorage
} from '@/utils/auth.js'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
import enLang from 'element-ui/lib/locale/lang/en'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖

import './styles/index.scss' // global css
import './styles/mixin.scss' // global css
import './assets/fonts/font.css' //字体
import '@/styles/variables.scss'
import '@/styles/variable-color.scss' // 全局颜色
import App from './App'
import store from './store'
import router from './router'
import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters

import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import {consoleDebugger} from "@/utils/index"
Vue.use(VueVideoPlayer)

import VueIntro from 'vue-introjs'
Vue.use(VueIntro)
import 'intro.js/introjs.css'

import Driver from 'driver.js'
import 'driver.js/dist/driver.min.css'
Vue.prototype.$driver = new Driver()

Vue.prototype.$driver = new Driver({
  // 设置提示框的 className, 默认 ''
  className: 'scoped-class',
  // 是否设置动画, 默认 true
  animate: true,
  // 背景不透明度（0表示只有弹出框，没有覆盖）
  opacity: 0.6,
  // opacity: 0.15,
  // 元素与边缘周围的距离
  padding: 10,
  // 点击遮罩层是否关闭, 默认 true
  allowClose: false,
  // 点击遮罩层进行下一步提示
  overlayClickNext: false,
  doneBtnText: '我知道了',
  closeBtnText: '跳过',
  // 高亮显示的元素的背景色
  nextBtnText: '下一项',
  prevBtnText: '上一步',
  // 是否显示控制按钮，默认为 true [ ture显示/false隐藏 ]
  showButtons: true,
  // 允许通过键盘进行控制（ESC退出关闭，左右箭头键移动）
  keyboardControl: true,
  scrollIntoViewOptions: {},
  // 当元素即将高亮显示时调用
  onHighlightStarted: (Element) => {

  },
  // 当元素完全高亮显示时调用
  onHighlighted: (Element) => {},
  // 取消选择元素时调用
  onDeselected: (Element) => {
  },
  // 将要清除覆盖时调用
  onReset: (Element) => {
    saveLocalStorage('zsm_guide', true)
  },
  // 移动到下一步骤时调用
  onNext: (Element) => {

  },
  // 移动到上一步骤时调用
  onPrevious: (Element) => {}
})

/**
 *
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  // const { mockXHR } = require('../mock')
  // mockXHR()
}

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
  // locale: enLang // 如果使用中文，无需设置，请删除
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


Vue.config.productionTip = false
if (process.env.NODE_ENV !== 'development') {
  consoleDebugger();
// 屏蔽错误信息
  Vue.config.errorHandler = (err) => {
    console.log(err)
  }
  // 屏蔽警告信息
  Vue.config.warnHandler = (message) => {
    
  }
  // 屏蔽输出内容
  console.log = function() {}
  console.error = function() {}
}

/**
 * 页面滚动到固定位置
 * @param {*} scroll 滚动位置
 * @param {*} delay   延迟时间
 * @param {*} el  滚动元素
 */
Vue.prototype.$pageScrollToEle = function pageScrollToEle(scroll, delay,el) {
  let element = document.getElementById(el||'shopInfo');
  if(element){
    element.scrollTo(scroll, delay);
  }
};

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
